/**
 * The code of a patient's linked scheme, plan or option. Stored as a MedPrax object (`{ code, name, ... }`); a few
 * older rows hold a bare code string, and empty values read as nothing.
 */
export function schemeCodeOf(value: unknown): string | null {
  const raw = typeof value === 'string' ? value : (value as { code?: unknown } | null | undefined)?.code;
  if (typeof raw !== 'string') return null;
  const code = raw.trim();
  return code && code !== 'null' ? code : null;
}

const nameIn = (value: unknown, key: 'name' | 'option'): string => {
  const raw = (value as Record<string, unknown> | null | undefined)?.[key];
  return typeof raw === 'string' ? raw.trim() : '';
};
const typedText = (value: unknown): string => (typeof value === 'string' ? value.trim() : '');

/**
 * The medical aid to show or print: what was typed, else the linked scheme, plan and option names. The server's
 * `schemeLink().displayName` / `displayPlan`.
 */
export function medicalAidDisplay(patient: unknown): { name: string; plan: string } {
  const p = (patient ?? {}) as Record<string, unknown>;
  const planName = nameIn(p['medicalPlanCode'], 'option') || nameIn(p['medicalPlanCode'], 'name');
  const optionName = nameIn(p['medicalPlanOptionCode'], 'option') || nameIn(p['medicalPlanOptionCode'], 'name');
  return {
    name: typedText(p['medicalAid']) || nameIn(p['medicalSchemeCode'], 'name'),
    plan: typedText(p['medicalAidPlan']) || [planName, optionName !== planName ? optionName : ''].filter(Boolean).join(' '),
  };
}
